import walkSheets from '../data/story/walk-sheets.json'

/**
 * A folha de caminhada de cada personagem no mundo (docs/21 secao 6). Gerada por `pnpm content:walk-sheets`.
 *
 * Uma grade fixa: `frames` quadros por linha, uma linha por direcao, na ordem de `rows`, cada quadro um
 * quadrado de `cell` px com o pe do personagem em `baseline`.
 */
export const STORY_WALK_SHEET = {
  cell: 232,
  frames: 8,
  baseline: 228,
  rows: ['down', 'left', 'right', 'up'],
} as const

const WITH_SHEET = new Set<string>(walkSheets.characters)

/** O personagem tem folha de caminhada? Sem ela, ou sem personagem, o jogador anda com o sprite padrao. */
export const hasWalkSheet = (characterId: string | null): boolean => characterId !== null && WITH_SHEET.has(characterId)

/** O caminho da folha dentro do `public/` do cliente do mundo. */
export const walkSheetPath = (characterId: string): string => `story/characters/${characterId}/walk.webp`
